import { render, staticRenderFns } from "./custom-product-thumbnails.vue?vue&type=template&id=ceb2492e&scoped=true"
import script from "./custom-product-thumbnails.vue?vue&type=script&lang=js"
export * from "./custom-product-thumbnails.vue?vue&type=script&lang=js"
import style0 from "./custom-product-thumbnails.vue?vue&type=style&index=0&id=ceb2492e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb2492e",
  null
  
)

export default component.exports